import VueRouter from 'vue-router';
import Dashboard from './views/pages/Dashboard.vue';

Vue.use(VueRouter);

let routes = [
    {
        path: '/',
        component: Dashboard,
        meta: {
            title: "dashboard",
        },
        alias: '/home',
        name: 'dashboard',
    }
];

routes = Vue.cmsRouter.setRoutes(routes);

// Change home dashboard
const homeRouteKey = routes.findIndex(route => route.path === '/');
routes[homeRouteKey] = {
    path: '/',
    component: Dashboard,
    meta: {
        title: "dashboard",
    },
    alias: '/home',
    children: [
        {
            path: '/dashboard-form/:bundle/:definition/:objectId/:relationString?',
            name: 'dashboard-form',
            components:{
                childview: {
                    template: '<cms-form-dashboard v-on="$listeners"/>',
                }
            },
        }
    ]
}

const router = new VueRouter({
    routes
})

Vue.cmsRouter.setActiveRouter(router);

export default router;
